<template>
    <!-- 循环块 -->
    <div>
      <el-row style="flex-wrap:wrap;"  type="flex" justify="center">
        <template v-for="(item,index) in value.childPageJsonArr" >
          <el-col v-if="item.dataInfo.BLOCK_IF_USE==1" :key="'block_'+index"   :xl="item.dataInfo.BLOCK_WIDTH?item.dataInfo.BLOCK_WIDTH:24" :lg="item.dataInfo.BLOCK_WIDTH?item.dataInfo.BLOCK_WIDTH:24" :md="24" :sm="24" :xs="24">
              <el-card :body-style="{padding:'5px'}" shadow="always" :style="'margin:3px;'+(item.dataInfo.CARD_STYLE?item.dataInfo.CARD_STYLE:'')" >
                  <div v-if="item.dataInfo.BLOCK_NAME != null && item.dataInfo.BLOCK_NAME != ''" slot="header">
                    <span style="font-weight: bold;color: #409eff;">{{item.dataInfo.BLOCK_NAME}}</span>
                    <el-button style="float: right; padding: 3px 0" type="text"  @click="refreshBlock(item)">刷新</el-button>
                  </div>
                  <!-- 循环块下边的内容 -->
                  <el-row v-if="item.ifLoad == null || item.ifLoad==true" style="flex-wrap:wrap;"  type="flex" justify="start">
                      <el-col v-for="(elementOne,elementIndex) in item.dataInfo.ELEMENT_LIST" :key="'element_'+elementIndex+(elementOne.refreshIndex?elementOne.refreshIndex:'0')" v-if="elementOne.ELE_IF_USE==1" :span="item.dataInfo.BLOCK_TYPE == 1?((visitSource==2?3:12)*(24/item.dataInfo.BLOCK_WIDTH)):24">
                      <!-- xl lg  -->
                          <template v-if="item.dataInfo.BLOCK_TYPE == 1">
                            <kw_name_value :mongoId="elementOne.ELE_ID" :roleId="roleId" :name="elementOne.ELE_NAME" :fieldOne="value" :isLimitButton="isLimitButton"></kw_name_value>
                          </template>
                          <template v-else-if="item.dataInfo.BLOCK_TYPE == 2">
                            <Report :ref="'listPage_'+item.menuId"  :pageInfo="{'reportId':elementOne.ELE_ID}" :initReportType=0 >
                            </Report>
                          </template>
                          <template v-else-if="item.dataInfo.BLOCK_TYPE == 3">
                            <Report :ref="'listPage_'+item.menuId"  :pageInfo="{'reportId':elementOne.ELE_ID}" :initReportType=1 >
                            </Report>
                          </template>
                          <template v-else-if="item.dataInfo.BLOCK_TYPE == 4">
                            <kw_list :initPageObj="{
                                'pageId':elementOne.ELE_ID,
                                'pageType':1,
                            }" :isLimitButton="isLimitButton" @goBack="goBack(elementOne)"></kw_list>
                          </template>
                          <template v-else-if="item.dataInfo.BLOCK_TYPE == 5">
                            <kw_look  :pageInfo="{
                              'pageId':elementOne.ELE_ID,
                              'pageType':11,
                              'mainId': loginInfo.USERID,
                            }" :isLimitButton="isLimitButton"></kw_look>
                          </template>
                      </el-col>
                  </el-row>
              </el-card>
          </el-col>
        </template>
      </el-row>
    </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
// kw_tabs 标签组组件
import kw_name_value from '@/components/kw/kw_name_value.vue';
import Report from '@/components/page/Report.vue'
export default {
  name: 'kw_work_plat',
  props: {
    roleId:String,
    value: {
      type: Object,
      value: {}
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      loginInfo:{},
    };
  },
  created() {
    //绑定用户信息
    if(localStorage.loginInfo) {
      this.loginInfo = JSON.parse(localStorage.loginInfo);
    }
  },
  mounted() {
    
  },
  watch:{

  },
  computed:{
  },
  components: {
    kw_name_value,
    Report,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    toDetailPage(childOne){
      var tableId = childOne.dataInfo.TABLE_ID;
      var pageId = childOne.dataInfo.PAGE_ID;
      var mainId = childOne.dataInfo.CLICK_DATA_ID;
      if (tableId > 0 && pageId > 0 && mainId > 0) {
        var jumpJson = {
          pageId: pageId,
          tableId: tableId,
          mainId: mainId,
          callBackType: 1
        };
        pageUtils.toNewLookPage(this,jumpJson);
      }
      // console.log("e====================",e);
      // console.log("childOne====================", childOne);
    },
    /**
     * 刷新块的信息
     */
    refreshBlock(item) {
      console.log("刷新===============",item);
      var that = this;
      item.ifLoad = false;
      that.$forceUpdate();
      that.$nextTick(function(){
        item.ifLoad = true;
        that.$forceUpdate();
      })
    },
    goBack(item){
      //刷新当前页面
      console.log("MainPage--------------goBack----------------",item);
      this.$set(item,"refreshIndex",((item.refreshIndex?item.refreshIndex:0)+1));
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-card /deep/ .el-card__header {
        padding: 10px;
    } 
</style>
